export const ill1 = require('./ill1-min.png');
export const ill2 = require('./ill2-min.png');
export const ill3 = require('./ill3-min.png');
export const ill4 = require('./ill4-min.png');
export const ill5 = require('./ill5-min.png');
export const project = require('./project-min.png');
